import React from 'react';
import { Text } from '@srcDS/js/components/typography/text/Text';
import { TextLink } from '@srcDS/js/components/atoms/textLink/TextLink';
import { FORM_TYPE } from '@srcDS/js/components/molecules/account/accountDropdown/AccountDropdown';
import styles from '../ProductActions.module.scss';
import { getCurrentLocale } from 'apgdev/src/js/utils/getCurrentLocale';
import { useGlobalSettings } from 'apgdev/src/js/utils/useGlobalSettings';

const AuthMessageComponent = ({ vipEnabled, isLoggedIn, data, signUpForm }) => {
  const currentSiteRegion = getCurrentLocale();
  const { vipDiscount } = useGlobalSettings({ locale: currentSiteRegion });

  return (
    <div className={styles.bottomBlock}>
      {vipEnabled && !isLoggedIn ? (
        <div className={styles.textLoggedBlock}>
          <Text
            weight="normal"
            textTransform="uppercase"
            className={`${styles.bottomText} ${styles.extandBottomText}`}
            as="span"
          >
            {data?.loggedOutMessage
              ? data.loggedOutMessage
              : `Enjoy ${vipDiscount}% Off Full Price with VIP 333:`}
          </Text>

          <div className={styles.linkLoggedBlock}>
            <TextLink
              onClick={() => signUpForm(FORM_TYPE.LOGIN, false)}
              className={styles.bottomLink}
            >
              Login
            </TextLink>
            <Text size="xs" as="span" className={styles.particleWord}>
              |
            </Text>
            <TextLink
              onClick={() => signUpForm(FORM_TYPE.REGISTER)}
              className={styles.bottomLink}
            >
              Join
            </TextLink>
          </div>
        </div>
      ) : (
        <Text
          weight="normal"
          textTransform="uppercase"
          className={styles.bottomText}
          as="span"
        >
          {data.loggedInMessage
            ? data.loggedInMessage
            : `VIP Discount: ${vipDiscount}% off applied in checkout`}
        </Text>
      )}
    </div>
  );
};

export default AuthMessageComponent;
